import companyGroupsService from "../shared/services/companyGroupsService";

const REQUEST_COMPANY_GROUPS = "REQUEST_COMPANY_GROUPS";
const RESPONSE_COMPANY_GROUPS = "RESPONSE_COMPANY_GROUPS";
const REQUEST_COMPANY_GROUPS_FAILURE = "REQUEST_COMPANY_GROUPS_FAILURE";

const requestCompanyGroupsAction = () => {
  return {
    type: REQUEST_COMPANY_GROUPS,
  };
};

const responseCompanyGroupsAction = (data) => {
  return {
    type: RESPONSE_COMPANY_GROUPS,
    data,
  };
};

const requestCompanyGroupsFailureAction = (errors) => {
  return {
    type: REQUEST_COMPANY_GROUPS_FAILURE,
    errors,
  };
};

const getCompanyGroups = () => {
  return (dispatch) => {
    dispatch(requestCompanyGroupsAction());

    companyGroupsService
      .getCompanyGroups()
      .then((responce) => {
        dispatch(responseCompanyGroupsAction(responce.data));
      })
      .catch((error) => {
        dispatch(requestCompanyGroupsFailureAction(error.response));
      });
  };
};

const SELECTED_GROUP = "SELECTED_GROUP";

const selectedGroupAction = (data) => {
  return {
    type: SELECTED_GROUP,
    data,
  };
};

const selectedGroup = (group) => {
  return (dispatch) => {
    dispatch(selectedGroupAction(group));
  };
};

const REQUEST_ADD_UNIT_GROUP = "REQUEST_ADD_UNIT_GROUP";
const RESPONSE_ADD_UNIT_GROUP = "RESPONSE_ADD_UNIT_GROUP";
const REQUEST_ADD_UNIT_GROUP_FAILURE = "REQUEST_ADD_UNIT_GROUP_FAILURE";

const requestAddUnitGroupAction = () => {
  return {
    type: REQUEST_ADD_UNIT_GROUP,
  };
};

const responseAddUnitGroupAction = (data) => {
  return {
    type: RESPONSE_ADD_UNIT_GROUP,
    data,
  };
};

const requestAddUnitGroupFailureAction = (errors) => {
  return {
    type: REQUEST_ADD_UNIT_GROUP_FAILURE,
    errors,
  };
};

const addUnitGroup = (groupId, unit) => {
  return (dispatch) => {
    dispatch(requestAddUnitGroupAction());

    companyGroupsService
      .addUnitGroups({ groupId, unitId: unit.id })
      .then((responce) => {
        dispatch(responseAddUnitGroupAction(unit));
      })
      .catch((error) => {
        dispatch(requestAddUnitGroupFailureAction(error.response));
      });
  };
};

const REQUEST_DEL_UNIT_GROUP = "REQUEST_DEL_UNIT_GROUP";
const RESPONSE_DEL_UNIT_GROUP = "RESPONSE_DEL_UNIT_GROUP";
const REQUEST_DEL_UNIT_GROUP_FAILURE = "REQUEST_DEL_UNIT_GROUP_FAILURE";

const requestDelUnitGroupAction = () => {
  return {
    type: REQUEST_DEL_UNIT_GROUP,
  };
};

const responseDelUnitGroupAction = (data) => {
  return {
    type: RESPONSE_DEL_UNIT_GROUP,
    data,
  };
};

const requestDelUnitGroupFailureAction = (errors) => {
  return {
    type: REQUEST_DEL_UNIT_GROUP_FAILURE,
    errors,
  };
};

const deleteUnitGroup = (groupId, unit) => {
  return (dispatch) => {
    dispatch(requestDelUnitGroupAction());

    companyGroupsService
      .deleteUnitGroups({ groupId, unitId: unit.id })
      .then((responce) => {
        dispatch(responseDelUnitGroupAction(unit));
      })
      .catch((error) => {
        dispatch(requestDelUnitGroupFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_GROUP = "REQUEST_CREATE_GROUP";
const RESPONSE_CREATE_GROUP = "RESPONSE_CREATE_GROUP";
const REQUEST_CREATE_GROUP_FAILURE = "REQUEST_CREATE_GROUP_FAILURE";

const requestCreateGroupAction = () => {
  return {
    type: REQUEST_CREATE_GROUP,
  };
};

const responseCreateGroupAction = (data) => {
  return {
    type: RESPONSE_CREATE_GROUP,
    data,
  };
};

const requestCreateGroupFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_GROUP_FAILURE,
    errors,
  };
};

const createGroup = (title) => {
  return (dispatch) => {
    dispatch(requestCreateGroupAction());

    companyGroupsService
      .createCompanyGroup({ title })
      .then((responce) => {
        dispatch(responseCreateGroupAction({ id: responce.data.id, title, units: [] }));
      })
      .catch((error) => {
        dispatch(requestCreateGroupFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_GROUP = "REQUEST_DELETE_GROUP";
const RESPONSE_DELETE_GROUP = "RESPONSE_DELETE_GROUP";
const REQUEST_DELETE_GROUP_FAILURE = "REQUEST_DELETE_GROUP_FAILURE";

const requestDeleteGroupAction = () => {
  return {
    type: REQUEST_DELETE_GROUP,
  };
};

const responseDeleteGroupAction = (data) => {
  return {
    type: RESPONSE_DELETE_GROUP,
    data,
  };
};

const requestDeleteGroupFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_GROUP_FAILURE,
    errors,
  };
};

const deleteGroup = (options) => {
  return (dispatch) => {
    dispatch(requestDeleteGroupAction());

    companyGroupsService
      .deleteCompanyGroup(options)
      .then((responce) => {
        dispatch(responseDeleteGroupAction(options));
      })
      .catch((error) => {
        dispatch(requestDeleteGroupFailureAction(error.response));
      });
  };
};

export {
  REQUEST_COMPANY_GROUPS,
  RESPONSE_COMPANY_GROUPS,
  REQUEST_COMPANY_GROUPS_FAILURE,
  getCompanyGroups,
  SELECTED_GROUP,
  selectedGroup,
  REQUEST_ADD_UNIT_GROUP,
  RESPONSE_ADD_UNIT_GROUP,
  REQUEST_ADD_UNIT_GROUP_FAILURE,
  addUnitGroup,
  REQUEST_DEL_UNIT_GROUP,
  RESPONSE_DEL_UNIT_GROUP,
  REQUEST_DEL_UNIT_GROUP_FAILURE,
  deleteUnitGroup,
  REQUEST_CREATE_GROUP,
  RESPONSE_CREATE_GROUP,
  REQUEST_CREATE_GROUP_FAILURE,
  createGroup,
  REQUEST_DELETE_GROUP,
  RESPONSE_DELETE_GROUP,
  REQUEST_DELETE_GROUP_FAILURE,
  deleteGroup,
};
